module.exports = __webpack_public_path__ + "static/media/afikoman-bag-back.38df360a.png";